/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProductView } from '../models/ProductView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductsService {
    /**
     * Get list of active products
     * @param pluginName Filter by plugin name. For content_master the matching add-on products (plugin_name content_master_addon_*) are included in the response.
     * @returns ProductView List of active products
     * @throws ApiError
     */
    public static getAppProductList(
        pluginName?: string,
    ): CancelablePromise<Array<ProductView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/products',
            query: {
                'plugin_name': pluginName,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
